angular.module('impactx.cscaccounting').controller('CSCAccountingCopyControlPanelCtrl', [
    '$scope',
    'themeFactory',
    'trns',
    'mdPanelRef',
    'onClose',
    'currentCSCId',
    CSCAccountingCopyControlPanelCtrl]);

function CSCAccountingCopyControlPanelCtrl($scope, themeFactory, trns, mdPanelRef, onClose, currentCSCId) {
    let self = this;

    $scope.theme = themeFactory.getTheme();
    $scope.trns = trns;
    $scope.currentCSCId = currentCSCId;

    self.apply = function () {
        mdPanelRef && mdPanelRef.close().then(function () {
            onClose($scope.data.selectedContract);
            $scope.data.selectedContract = undefined;
            $scope.data.currentCSCId = 0;
        });
    }
}